module.exports = __webpack_public_path__ + "media/application/images/2018/icon-dont-buy-16946100a5dbee1e2a97cbbf3cbd0e06.svg";